SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportCancelOrderServiceActionView extends SupportServiceActionsBaseView
  id: 'cancel_order'

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id : 'cancel_order'
      service_action : I18n.t("js.modules.support.cancel_order")
    @extendHash(hash)

  actionHandler: (event)->
    dealPermalink = Groupon.Support.currentOrder.deal.id
    orderId = Groupon.Support.currentOrder.id
    url = "/deals/#{ dealPermalink }/confirmation/#{ orderId }#toggle-inputs"

    openLocation url

  events :
    "click #cancel_order" : "actionHandler"

module.exports = SupportCancelOrderServiceActionView
